/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */

// Google Consent Mode
window.dataLayer = window.dataLayer || []
function gtag() {
  window.dataLayer.push(arguments)
}

gtag('consent', 'default', {
  ad_storage: 'denied',
  analytics_storage: 'denied',
})

window.dataLayer.push({
  event: 'default_consent',
});

// Google Tag Manager
(function (w, d, s, l, i) {
  w[l] = w[l] || []
  w[l].push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  })
  const f = d.getElementsByTagName(s)[0]
  const j = d.createElement(s)
  const dl = l === 'dataLayer' ? '' : `&l=${l}`
  j.async = true
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
  f.parentNode.insertBefore(j, f)
})(window, document, 'script', 'dataLayer', 'GTM-5DX4ZM5')
